export default function initIntroAnimation() {
  if (document.querySelector('.intro')) {
    document.querySelector('.intro').classList.add('animate');
  }
}
